import { useQuery } from "react-query";
import { useInterfaceAccess } from "../../hooks/useInterfaceAccess";
import { getUserInfo } from "./candidate-assignments/service";
import { AB_VAULT_INTERFACE_ID, type VaultTool } from "./config";

export type VaultToolsState =
  | { status: "pending" }
  | { status: "error" }
  | { status: "ready"; tools: VaultTool[] };

/** The Vault tools this user may use; the tabs, the mode row and the route gate all read this. */
export function useVaultTools(): VaultToolsState {
  const access = useInterfaceAccess(AB_VAULT_INTERFACE_ID);
  const { data, isError } = useQuery(["ab-vault-user-info"], getUserInfo, {
    enabled: access.status === "granted",
  });
  if (data) {
    return { status: "ready", tools: data.tools ?? [] };
  }
  return { status: isError ? "error" : "pending" };
}
